import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbDateParserFormatter, NgbDateStruct, NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

import { DatePickerParser } from './datepicker-parser';
import moment from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  providers: [
    { provide: NgbDateParserFormatter, useClass: DatePickerParser },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true,
    },
  ],
})
export class DatepickerComponent implements ControlValueAccessor {
  @Input() public invalid: boolean;
  @Input() public isDisabled: boolean = false;

  public model: NgbDateStruct;

  constructor(public config: NgbInputDatepickerConfig) {
    this.config.minDate = { year: 1900, month: 1, day: 1 };
    this.config.maxDate = { year: 2099, month: 12, day: 31 };
    this.config.outsideDays = 'collapsed';
    this.config.container = 'body';
  }

  public onChange = (date: Date): void => {};

  public onTouched = (): void => {};

  public get value(): Date | undefined {
    if (this.model) {
      return moment({
        year: this.model.year,
        month: this.model.month - 1,
        day: this.model.day,
        hour: 12,
        minute: 0,
      }).toDate();
    }
    return undefined;
  }

  public writeValue(value: Date | string): void {
    const selectDate: Date = value ? (moment.isDate(value) ? value : new Date(value)) : undefined;
    if (selectDate) {
      this.model = {
        day: selectDate.getDate(),
        month: selectDate.getMonth() + 1,
        year: selectDate.getFullYear(),
      };
      this.onChange(this.value);
    } else {
      this.model = null;
      this.onChange(this.value);
    }
  }

  public registerOnChange(fn: (date: Date) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public selectInput(): void {
    this.onChange(this.value);
  }

  public checkInput(): void {
    this.onChange(this.value);
  }
}
